import React, { useContext, Fragment } from "react";
import { LangCtx } from "../../../lib/context";
import "../../../ui-styles/bottomSlider/BottomSlider.css";
import "../../../ui-styles/prescription/prescriptionAdd.css";
import InputField from "../../../lib/ui/inputs/Input";
import TextArea from "../../../lib/ui/inputs/TextArea";
import DropDown from "../../../lib/ui/dropdown/Dropdown";

import "../../../ui-styles/picker/picker.css";

const doseOptionList = [
    { value: "", label: "Medicine Unit" },
    { value: "Drop", label: "Drop" },
    { value: "gm", label: "gm" },
    { value: "ML", label: "ML" },
    { value: "mg", label: "mg" },
    { value: "Spoon", label: "Spoon" },
    { value: "TAB", label: "TAB" },
];
const perDoseList = [
    { value: "", label: "Drug Type" },
    { value: "capsule", label: "capsule" },
    { value: "tonic", label: "tonic" },
    { value: "tablet", label: "tablet" },
];
const howMuchDoseList = [
    { value: "", label: "Take(In a Day)*" },
    { value: "night", label: "0-0-1" },
    { value: "afternoon", label: "0-1-0" },
    { value: "morning", label: "1-0-0" },
    { value: "morning-night", label: "1-0-1" },
    { value: "morning-afternoon", label: "1-1-0" },
    { value: "morning-afternoon-night", label: "1-1-1" },
];
const whenDoseList = [
    { value: "", label: "When*" },
    { value: "beforeMeal", label: "Before Meal" },
    { value: "afterMeal", label: "After Meal" },
];

const AddDrug = (props) => {
    const { l } = useContext(LangCtx);
    //  const { payload } = useContext(PayLoadCtx);

    const removeDrug = () => {
        props.removeDrug(props.index);
    };

    return (
        <Fragment>
            <div className="presInputCntnr">
                <div className="presTopActn">
                    {props.index > 0 ? (
                        <div className="actnBox" onClick={removeDrug}>
                            <img src="/images/icons/delete-outline.png" alt="icon" className="actnIcon invertPrimary" />
                            <span className="actnTxtPrimary">{l.delete}</span>
                        </div>
                    ) : (
                        <div></div>
                    )}
                </div>
                <div className="presInputBdy">
                    <div className="inputInlineGroup">
                        <div className="inputInlineItem">
                            <InputField
                                placeholder={l.drug_name}
                                type="text"
                                maxLength="30"
                                value={props.data.drugname}
                                onChange={(e) => props.handleChange("drugname", e.target.value, props.index)}
                            />
                        </div>
                        <div className="inputInlineItem">
                            <div className="inputRow">
                                <div className="inputFlex">
                                    <InputField
                                        placeholder={l.take_dose}
                                        type="text"
                                        maxLength="30"
                                        value={props.data.takePerDose}
                                        onChange={(e) => props.handleChange("takePerDose", e.target.value, props.index)}
                                    />
                                </div>
                                <div className="inputAuto">
                                    <DropDown
                                        placeholder={l.inp_tab}
                                        items={perDoseList}
                                        value={props.data.drugType}
                                        onChange={(e) => props.handleChange("drugType", e.target.value, props.index)}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="inputInlineGroup">       
                        <div className="inputInlineItem">
                            {/* <div className="inputRow"> */}
                                <div className="inputAuto">
                                    <DropDown
                                        placeholder={l.med_unit}
                                        items={doseOptionList}
                                        value={props.data.medicalUnit}
                                        onChange={(e) => props.handleChange("medicalUnit", e.target.value, props.index)}
                                    />
                                </div>
                                <div className="inputFlex">
                                    <InputField
                                        placeholder="Dose"
                                        type="text"
                                        size="fullWidth"
                                        maxLength="30"
                                        value={props.data.dose}
                                        onChange={(e) => props.handleChange("dose", e.target.value, props.index)}
                                    />
                                </div>
                            {/* </div> */}
                        </div>
                    </div>
                    <div className="inputInlineGroup">
                        <div className="inputChildGroup">
                            <div className="inputInlineItem">
                                <DropDown
                                    placeholder={l.take_day}
                                    items={howMuchDoseList}
                                    value={props.data.doseInDay}
                                    onChange={(e) => props.handleChange("doseInDay", e.target.value, props.index)}
                                    size="fullWidth"
                                />
                            </div>
                            <div className="inputInlineItem">
                                <DropDown
                                    placeholder={l.inp_tab}
                                    items={whenDoseList}
                                    value={props.data.whenDose}
                                    // className="handleSelect"
                                    onChange={(e) => props.handleChange("whenDose", e.target.value, props.index)}
                                    size="fullWidth"
                                />
                            </div>
                            <div className="inputInlineItem">
                                <InputField
                                    placeholder={l.inp_fordays}
                                    type="text"
                                    value={props.data.forDays}
                                    onChange={(e) => props.handleChange("forDays", e.target.value, props.index)}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="inputInlineGroup">
                        <div className="inputInlineItem">
                            <TextArea
                                placeholder={l.note}
                                value={props.data.notes}
                                type="text"
                                onChange={(e) => props.handleChange("notes", e.target.value, props.index)}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

export default AddDrug;
